import React from "react";
import Select from "./Select";

export default class Bool extends React.Component<any, any> {
  render() {
    return (
      <Select
        list={[
          ["true", "Yes"],
          ["false", "No"],
        ]}
        {...this.props}
      />
    );
  }
}
